<template>
  <div class="test_form">
    <div class="test_form_header">
      <div class="test_form_title">1. Examen de conocimiento del idioma</div>
      <div class="test_form_level" v-if="exam">
        {{ result.description_level }}
      </div>
      <div class="test_form_timer">
        <div class="clock">
          <img src="@/assets/images/evaluation/clock.svg" alt="" />
          <div class="clock_time">
            {{ currentTimeDisplay }}
          </div>
        </div>
        <div class="progress">
          <v-progress-linear
            height="13"
            :value="currentPercent"
            rounded
          ></v-progress-linear>
        </div>
      </div>
    </div>
    <div class="test_form_content" v-if="exam && !loading">
      <div
        class="test_question_group"
        v-for="(question, index) in exam.questions"
        :key="`question` + index"
      >
        <div
          class="test_question"
          v-html="index + 1 + ` - ` + question.question_text"
        ></div>
        <div class="test_question_options">
          <v-radio-group :mandatory="false" row v-model="answers[index]">
            <div
              v-for="(option, idx) in question.alternatives"
              :key="`option_` + idx"
            >
              <v-radio
                color="#41424E"
                :label="option.alternative_name"
                :value="`${question.question_id}-${option.alternative_id}`"
              >
                <template v-slot:label>
                  <div
                    class="test_question_options_label"
                    v-html="option.alternative_name"
                  ></div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
    </div>
    <div class="test_form_content" v-if="loading">
      <div v-for="(n, index) in 10" :key="index" class="test_question_group">
        <div class="test_question d-flex justify-start">
          <div class="mr-2" style="margin-top: -5px">{{ index + 1 }} -</div>
          <v-skeleton-loader type="text" class="sk-question" v-bind="attrs">
          </v-skeleton-loader>
        </div>
        <div class="sk-options">
          <v-skeleton-loader
            type="text"
            class="sk-answer"
            v-bind="attrs"
            v-for="(n, index) in 4"
            :key="`aws${index}`"
          >
          </v-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="test_form_footer">
      <v-btn
        color="primary"
        class="uppercase"
        @click="nextLevel"
        :disabled="isDisabled"
        :loading="loading"
      >
        Continuar
      </v-btn>
    </div>
    <v-dialog v-model="dialog" width="525">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog = false">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="dialog">
          <div class="dialog_complete">
            Has completado el nivel
          </div>
          <div class="dialog_level" v-if="exam">
            {{ exam.level_name }}
          </div>
          <div class="dialog_icon">
            <span class="material-icons">
              check_circle
            </span>
          </div>
          <div class="dialog_description" v-if="exam">
            {{ exam.description }}
          </div>
          <div class="dialog_footer">
            <v-btn color="primary" class="uppercase" @click="toContinue()">
              Continuar
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "@/axios-auth";
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
moment.locale("es-do");

export default {
  data() {
    return {
      user: null,
      percent: 50,
      dialog: false,

      exam: null,
      result: null,
      recognition: null,
      level: null,
      answers: [],
      isDisabled: true,
      loading: false,

      gapTime: 0,
      currentTime: null,
      currentTimeDisplay: "00:00",
      intervalTime: null,
      attrs: {
        class: "mb-6",
        boilerplate: true
      }
    };
  },
  methods: {
    ...mapActions(["verifyPostulation"]),
    ...mapMutations(["setExamFinished"]),

    sendExam(eId, pId, lId) {
      let answers_level = this.prepareAnswers();
      this.loading = true;
      let obj = {
        postulation_id: pId,
        exam_id: eId,
        level_id: lId,
        answers_level: eId == 0 ? [] : answers_level
      };
      axios
        .post(`users/register-exam/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          this.$vuetify.goTo("#top", {
            duration: 0,
            offset: 0,
            easing: "linear"
          });

          this.loading = false;
          this.exam = response.data.exam;
          this.result = response.data.result;
          this.recognition = response.data.recognition;
          this.gapTime = this.result.time * 60;
          this.currentTimeDisplay = "0:00";
          clearInterval(this.intervalTime);

          this.exam.questions.sort((a, b) =>
            a.question_order > b.question_order
              ? 1
              : b.question_order > a.question_order
              ? -1
              : 0
          );

          this.answers = [];

          if (this.result.exam_finished) {
            this.setExamFinished(this.result);
            this.$emit("completed");
          } else if (eId != 0 && answers_level.length != 0) {
            this.dialog = true;
          } else {
            this.setTimer();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    nextLevel() {
      this.sendExam(
        this.result.exam_id,
        this.postulation.id,
        this.result.level_id
      );
    },
    prepareAnswers() {
      let newAnswers = [];
      this.answers.map(element => {
        let ids = element.split("-");
        newAnswers.push({
          question_id: parseInt(ids[0]),
          alternative_id: parseInt(ids[1])
        });
      });

      // console.log(newAnswers);
      return newAnswers;
    },
    validation() {
      this.dialog = true;
    },
    complete() {
      this.dialog = false;
      this.$emit("completed");
    },
    consultApplication() {
      // console.log("consultApplication");
      // console.log(this.postulation);
      switch (this.postulation.status.id) {
        case 1:
        case 2:
          this.sendExam(0, this.postulation.id, this.program.first_level);
          break;

        case 3:
          this.sendExam(
            this.postulation.examns[0].id,
            this.postulation.id,
            this.postulation.examns[0].step
          );
          break;
      }
    },
    toContinue() {
      this.setTimer();
      this.dialog = false;
    },
    setTimer() {
      (this.currentTime = moment(new Date(0, 0, 0, 0, 0, this.gapTime, 0))),
        // console.log(this.currentTime.format("mm:ss"));
      this.intervalTime = setInterval(() => this.updateCurrentTime(), 1 * 1000);
    },
    updateCurrentTime() {
      if (this.gapTime > 0) {
        this.gapTime--;
        this.currentTime.subtract(1, "seconds");
        this.currentTimeDisplay = this.currentTime.format("mm:ss");
      } else {
        this.nextLevel();
        clearInterval(this.intervalTime);
      }
    }
  },
  computed: {
    ...mapGetters({
      language: "language",
      program: "program",
      postulation: "postulation",
      postulationIsNull: "postulationIsNull"
    }),
    totalAnswers() {
      let count = 0;
      for (let index = 0; index < this.answers.length; index++) {
        if (this.answers[index]) count++;
      }
      return count;
    },
    currentPercent() {
      if (this.result) {
        return (this.result.current * 100) / this.result.total;
      }
      return 0;
    }
  },
  mounted() {
    this.user = this.$store.state.usuario;

    this.verifyPostulation();
    if (!this.postulationIsNull) {
      // console.log("mounted - !postulationIsNull");
      this.consultApplication();
    }
  },
  watch: {
    answers(val) {
      if (this.totalAnswers == this.exam.questions.length) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    }
  }
};
</script>
